/* Campaign content and navigation are server rendered; only media state needs JS. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-giesto-campaigns] [data-campaign-media]').forEach(frame => {
      if (frame.dataset.campaignBound) return;
      frame.dataset.campaignBound = 'true';
      const image = frame.querySelector('img');
      if (!image) return;
      const settle = () => { frame.dataset.mediaState = image.naturalWidth ? 'loaded' : 'error'; };
      image.addEventListener('load', settle);
      image.addEventListener('error', settle);
      // Both listeners precede complete to avoid missing a cache-hit load event.
      if (image.complete) settle();
      else frame.dataset.mediaState = 'pending';
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
